module.exports = __webpack_public_path__ + "img/banner.c4a246ca.png";